// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kq-1";
export var rowFirst = "_kq-3";
export var rowLast = "_kq-5";
export var rowMiddle = "_kq-4";
export var ticketListScroll = "_kq-2";
export var ticketStack = "_kq-0";